import eikeni from '../img/eikeni.jpg'
import { Helmet } from 'react-helmet'
import { useTextService } from '../services/useTextService'

function AboutUs() {

  const { getValueByTag, getPlainValueByTag } = useTextService()

  return (
    <div className='about-us padding-10-bottom'>
      <Helmet>
        <title>Nora Spora - Par mums</title>
        <meta name="description" content="Nora Spora piedāvā plašu klāstu sēņu audzēšanas komplektu, tostarp rozā un pelēkās austersēnes, ežu dižadatenes, gļotainās zvīņenes un drīzumā arī citas." />
        <meta name="keywords" content="nora, spora, sporas, noraspora, supersenes, supersēnes, super, sēnes, maple garden, kļavas dārzs, svaigas sēnes, Trubenieki, Eco Fungus, Austersēnes, Sēņu laboratorija Spora, baravikas, gailenes, bekas, micēlijs, micēlija tapiņas, micēlija dībeļi, rozā austersēnes, austeres, pelēkās austersēnes, zilās austersēnes, lions mane, ežu dižadatene, reiši, reishi, shitake, šitake, šitaki, dzeltenās austersēnes, zeltainās austersēnes, zelta austersēnes, dāvana, dāvanas, hobijs, ekoloģisks, bioloģisks, bio, eko, dabīgs, latvijas sēnes" />
      </Helmet>
      <div className="two-column-flex">
        <div className="left">
          <div className="about-us-media">
            <img src={eikeni} alt="Eikeni" />
          </div>
        </div>
        <div className="right">
          <div className="about-us-content">
            <h2 className='light padding-20-bottom'>{getPlainValueByTag('par-mums-title')}</h2>
            <div dangerouslySetInnerHTML={getValueByTag('par-mums')}></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUs
